import React from "react";

import { ReactComponent as ActionIcon } from "../../../assets/svg/actionlist_modal_icon.svg";
import { ReactComponent as CloseIcon } from "../../../assets/svg/close_gray.svg";

import styles from "./ProjectionScreenModal.module.scss";
type ActionlistModalProps = {
  onClose: () => void;
};
const ProjectionScreenModal: React.FC<ActionlistModalProps> = ({ onClose }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <ActionIcon className={styles.actionIcon} />
        <CloseIcon className={styles.closeIcon} onClick={onClose} />
      </div>
      <div className={styles.body}>
        <h1 className={styles.title}>
          授業で学んだことを使って、行動してみましょう。
        </h1>
        <div className={styles.section}>
          <p className={styles.description}>
            振り返りWORKに入力した内容は、生徒画面の［行動リスト］に表示されます。
            <br />
            学んだことを授業外で実践し、
            <br />
            実践後は行動の内容や気づきを［行動リスト］に入力してみましょう。
          </p>
        </div>
        <div className={styles.displayImage} />
      </div>
    </div>
  );
};

export default ProjectionScreenModal;
